<template>
  <div>
    <el-card>
      <div class="carditem">
        <div class="title" v-for="item in yearList" :key="item">
          <i class="el-icon-caret-right"></i>
          <p @click="goDetails(item)">{{ item + "年年度成绩表" }}</p>
        </div>
      </div>
      <div class="page">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currPage"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="totalSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currPage: 1,
      totalSize: 10,
      total: 0,
      yearList: [],
    };
  },
  created() {
    this.getYearList();
  },
  methods: {
    async getYearList() {
      const { data: res } = await this.$http.post("quality/data/yearList", {
        currPage: this.currPage,
        totalSize: this.totalSize,
      });
      if (res.code !== 200) {
        this.$message.error(res.message);
      } else {
        this.yearList = res.data.records;
        this.total = res.data.total;
      }
    },
    goDetails(year) {
      this.$router.push({
        path: "/useryearscorelist",
        query: {
          year: year,
        },
      });
    },
    // 每页显示条数变化
    handleSizeChange(newSize) {
      this.totalSize = newSize;
      this.currPage = 1;
      this.getYearList();
    },
    // 当前页变化
    handleCurrentChange(newPage) {
      this.currPage = newPage;
      this.getYearList();
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  margin-top: 20px;
}
</style>
